import type { City } from '../types'

export const cities: City[] = [
  {
    slug: 'shelton-wa',
    name: 'Shelton',
    county: { en: 'Mason County', es: 'Condado de Mason' },
    homeBase: true,
    responseTime: { en: 'Same-day inspections', es: 'Inspecciones el mismo día' },
    blurb: {
      en: 'Our home base. Shelton’s high water table and older post-and-beam homes make crawl space moisture and wood rot the most common calls we take here.',
      es: 'Nuestra base. El nivel freático alto de Shelton y las casas antiguas de poste y viga hacen que la humedad en crawl spaces y la pudrición de madera sean lo más común aquí.',
    },
  },
  {
    slug: 'seattle-wa',
    name: 'Seattle',
    county: { en: 'King County', es: 'Condado de King' },
    responseTime: { en: 'Inspections within 48 hours', es: 'Inspecciones en 48 horas' },
    blurb: {
      en: 'Century-old Seattle homes on sloped lots settle unevenly. We handle foundation crack repair and structural restoration across every neighborhood.',
      es: 'Las casas centenarias de Seattle en terrenos inclinados se asientan de forma despareja. Reparamos grietas y restauramos estructuras en todos los barrios.',
    },
  },
  {
    slug: 'tacoma-wa',
    name: 'Tacoma',
    county: { en: 'Pierce County', es: 'Condado de Pierce' },
    responseTime: { en: 'Inspections within 48 hours', es: 'Inspecciones en 48 horas' },
    blurb: {
      en: 'Tacoma basements take on water every winter. Our drainage, sump pump, and sealing systems keep them dry year-round.',
      es: 'Los sótanos de Tacoma se inundan cada invierno. Nuestros sistemas de drenaje, bombas y sellado los mantienen secos todo el año.',
    },
  },
  {
    slug: 'auburn-wa',
    name: 'Auburn',
    county: { en: 'King County', es: 'Condado de King' },
    responseTime: { en: 'Inspections within 48 hours', es: 'Inspecciones en 48 horas' },
    blurb: {
      en: 'Valley-floor moisture in Auburn drives wood rot and failing support posts. We replace and protect the structure underneath your floors.',
      es: 'La humedad del valle en Auburn causa pudrición y postes de soporte dañados. Reemplazamos y protegemos la estructura bajo tus pisos.',
    },
  },
  {
    slug: 'olympia-wa',
    name: 'Olympia',
    county: { en: 'Thurston County', es: 'Condado de Thurston' },
    responseTime: { en: 'Same-day inspections', es: 'Inspecciones el mismo día' },
    blurb: {
      en: 'Olympia homeowners call us for insulation upgrades and crawl space encapsulation that cut heating costs through the wet season.',
      es: 'En Olympia nos llaman por mejoras de aislamiento y encapsulado de crawl space que reducen los costos de calefacción en temporada húmeda.',
    },
  },
  {
    slug: 'federal-way-wa',
    name: 'Federal Way',
    county: { en: 'King County', es: 'Condado de King' },
    responseTime: { en: 'Inspections within 48 hours', es: 'Inspecciones en 48 horas' },
    blurb: {
      en: 'Sagging, bouncy floors are the top complaint in Federal Way. Smart jacks and joist reinforcement bring them back to level.',
      es: 'Los pisos hundidos son la queja principal en Federal Way. Los smart jacks y el refuerzo de viguetas los devuelven a nivel.',
    },
  },
  {
    slug: 'kirkland-wa',
    name: 'Kirkland',
    county: { en: 'King County', es: 'Condado de King' },
    responseTime: { en: 'Inspections within 48 hours', es: 'Inspecciones en 48 horas' },
    blurb: {
      en: 'From lakefront properties to newer builds, Kirkland homes get full foundation inspections and moisture control solutions.',
      es: 'Desde propiedades frente al lago hasta construcciones nuevas, en Kirkland ofrecemos inspecciones completas y control de humedad.',
    },
  },
  {
    slug: 'aberdeen-wa',
    name: 'Aberdeen',
    county: { en: 'Grays Harbor County', es: 'Condado de Grays Harbor' },
    responseTime: { en: 'Same-day inspections', es: 'Inspecciones el mismo día' },
    blurb: {
      en: 'Coastal rainfall is relentless in Aberdeen. Encapsulation and rot repair protect homes built long before modern moisture standards.',
      es: 'La lluvia costera es constante en Aberdeen. El encapsulado y la reparación de pudrición protegen casas construidas antes de los estándares modernos.',
    },
  },
]

export const extraAreas = ['Centralia', 'Montesano', 'Lacey', 'Puyallup', 'Renton', 'Chehalis', 'Elma', 'Bremerton']

export function getCity(slug?: string) {
  return cities.find((c) => c.slug === slug)
}
